import { computed, type Ref } from 'vue';

export interface SortByNameOptions<T> {
  list: Ref<T[]>;
  getName: (entity: T) => string;
}

export function useSortByName<T>(options: SortByNameOptions<T>) {
  const { getName } = options;

  return computed(() => {
    const clone = Array.from(
      options.list.value.map((e) => {
        return {
          ...e,
          nameSortOrder: 0,
        };
      }),
    );
    clone.sort((a, b) => getName(a).localeCompare(getName(b), undefined, { numeric: true }));

    for (let index = 0; index < clone.length; index++) {
      const element = clone[index];
      if (element) {
        element.nameSortOrder = index;
      }
    }

    return clone;
  });
}
